<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="font-weight: bold;"><i class="el-icon-s-custom text-blue" style="margin-right: 5px;"></i>意向客户</span>
    </div>

    <el-table :data="list" v-loading="loading" style="width: 100%">
      <el-table-column label="头像" width="80" align="center">
        <template slot-scope="scope">
          <el-avatar :size="40" :src="scope.row.avatar" icon="el-icon-user-solid"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称" min-width="120">
        <template slot-scope="scope">
          <span style="cursor: pointer; color: #409EFF;" @click="handleNicknameClick(scope.row)">{{ scope.row.nickname }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ownerNickname" label="负责人昵称" min-width="120"></el-table-column>
      <el-table-column prop="from" label="来源" width="80"></el-table-column>
      <el-table-column prop="city" label="城市" width="80"></el-table-column>
      <el-table-column prop="brand" label="品牌" width="80"></el-table-column>
      <el-table-column label="时间" width="160">
        <template slot-scope="scope">
          <div style="font-size:11px">
            <div style="color: #409EFF;">通过时间/活跃时间</div>
            <div>{{ scope.row.passTime | dateFormat }}</div>
            <div>{{ scope.row.lastActivityTime | dateFormat }}</div>
          </div>

        </template>
      </el-table-column>

    </el-table>

    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[10, 20, 50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'IntentionCustomers',
  props: {
    targetType: {
      type: String,
      default: 'personal'
    },
    url: {
      type: String,
      default: 'zhaoshang/zhuanyuan/intentionCustomers'
    },
    employeeId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      list: [],
      total: 0,
      queryInfo: {
        page: 1,
        pageSize: 10
      }
    }
  },
  created () {
    // this.fetchData()
  },
  watch: {
    employeeId: {
      handler () {
        if (this.employeeId) {
          this.fetchData()
        }
      },
      immediate: true
    }
  },
  methods: {
    async fetchData () {
      this.loading = true
      try {
        const params = {
          ...this.queryInfo,
          targetType: this.targetType
        }

        if (this.employeeId) {
          params.employeeId = this.employeeId
        }

        const { data: res } = await this.$http.get(this.url, { params })

        if (res.meta.status === 200) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.meta.msg)
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取意向客户列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.fetchData()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.page = newPage
      this.fetchData()
    },
    handleNicknameClick (row) {
      this.$emit('view-wechat-history', row)
    }
  }
}
</script>

<style scoped>
.text-blue { color: #409EFF; }
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
